import { useSelector } from "react-redux";
// @ts-expect-error: ignoring as it is existing js file
import { userDetailsSelector } from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, UserDetailsState } from "@/store/slices/types/applicationFormSlice";
import { LenderCardProvider } from "@/providers/LenderCardContextProvider";
import type {
  LenderProduct,
  RemainingDataFields,
} from "@/providers/LenderCardContextProvider/types/LenderProductTypes";
import { LenderCardCondensed } from "./LenderCardCondensed";
import { LenderCardDetailed } from "./LenderCardDetailed";

interface LenderProductCardProps {
  productDetails: LenderProduct | undefined;
  showRequiredFields: (fields: RemainingDataFields) => void;
  isSingleLenderProduct: boolean;
}

const LenderProductCard = ({ productDetails, showRequiredFields, isSingleLenderProduct }: LenderProductCardProps) => {
  const { open: isLenderProductDrawerOpen } = useSelector<ApplicationFormSlice, UserDetailsState>(userDetailsSelector);

  return (
    <LenderCardProvider
      productDetails={productDetails}
      showRequiredFields={showRequiredFields}
      isSingleLenderProduct={isSingleLenderProduct}
    >
      {isLenderProductDrawerOpen ? <LenderCardDetailed /> : <LenderCardCondensed />}
    </LenderCardProvider>
  );
};

export { LenderProductCard };
